<template>
  <el-row class="container">
    <el-col :sm="24" class="header">
      <el-col
        
        :xs="12"
        class="logo"
        :class="collapsed?'logo-collapse-width':'logo-width'" 
      >
      <img src="../assets/sllogo.png" class="logoImg" v-if="!collapsed" @click="goHome()" /> 
      <span @click="goHome()">小森林</span>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <span @click="$router.push('/product/index')">{{collapsed?'':sysName}}</span>
    </el-col>
      <!--<el-col  :xs="12" :sm="10" class="middle">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>-->
      <el-col :xs="24" :sm="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">
           <!-- <img src="../assets/user.jpg">-->
            {{uName}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>我的消息</el-dropdown-item>
            <el-dropdown-item>设置</el-dropdown-item>-->
            <!-- 退出登录 -->
            <el-dropdown-item @click.native="cpwd">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :sm="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <!-- unique-opened -->
        <el-menu
          :default-active="dpath"
          :class="[!collapsed?'expanded':'', 'el-menu-vertical-demo']"
          
          @select="handleselect"
          router
          unique-opened
          v-show="!collapsed"
        >
          <template v-for="(item,index) in menu">
            <el-submenu :index="index+''" :key="item.id" v-if="item.child">
              <template slot="title">
                <i :class="iconClass[index]"></i>
                {{item.name}}
              </template>
              <el-menu-item
                v-for="child in item.child"
                :index="'/'+child.url"
                :key="child.id"
              >{{child.name}}</el-menu-item>
            </el-submenu>
           <el-menu-item v-if="!item.child&&item.url"  :index="'/'+item.url" :key="item.id"  @click="$router.push('/'+item.url)">
              <i :class="iconClass[index]"></i>
              {{item.name}}
            </el-menu-item>
          </template>
        </el-menu>
        <!--导航菜单-折叠后-->
        <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
          <li v-for="(item,index) in menu" class="el-submenu item" :key="item.id">
            <template v-if="item.child">
              <div
                class="el-submenu__title"
                style="padding-left: 20px;"
                @mouseover="showMenu(index,true)"
                @mouseout="showMenu(index,false)"
              >
                <i :class="iconClass[index]"></i>
              </div>
              <ul
                class="el-menu submenu"
                :class="'submenu-hook-'+index"
                @mouseover="showMenu(index,true)"
                @mouseout="showMenu(index,false)"
              >
                <li
                  v-for="child in item.child"
                  :key="child.id"
                  class="el-menu-item"
                  style="padding-left: 40px;"
                  :class="$route.path==child.url?'is-active':''"
                  @click="$router.push('/'+child.url)"
                >{{child.name}}</li>
              </ul>
            </template>
            <template v-else>
              <li class="el-submenu" @click="$router.push('/'+item.url)">
                <div
                  class="el-submenu__title"
                  style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;"
                  :class="$route.path==item.url?'is-active':''"
                  @click="$router.push(item.url)"
                >
                  <i :class="iconClass[index]"></i>
                </div>
              </li>
            </template>
          </li>
        </ul>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :sm="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view ref="myMain"></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>

    <el-dialog title="修改密码" :visible.sync="updatePwd" width="400px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="请输入原密码" label-width="120px" prop="old_password">
          <el-input style="width:200px" v-model="form.old_password" show-password></el-input>
        </el-form-item>
        <el-form-item label="请输入新密码" label-width="120px" prop="new_password">
          <el-input style="width:200px" v-model="form.new_password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" label-width="120px" prop="checkPass">
          <el-input style="width:200px" v-model="form.checkPass" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePwd = false">取 消</el-button>
        <el-button type="primary" @click="changePwd">确 定</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import { smenu, sconfig, swxapp, slist, splist, scpwd } from "../api/api";
export default {
  data() {
    var nPass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("新密码不能为空!"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能低于6位"));
      } else {
        callback();
      }
    };
    var vPass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("确认密码不能为空!"));
      } else if (value !== this.form.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        old_password: [
          { required: true, message: "原密码不能为空", trigger: "change" }
        ],
        new_password: [{ required: true, validator: nPass, trigger: "blur" }],
        checkPass: [{ validator: vPass, required: true, trigger: "blur" }]
      },
      screenWidth: document.body.clientWidth,
      sysName: "卖量后台",
      collapsed: false,
      uName: "",
      menu: [],
      iconClass: [
        "el-icon-mobile-phone",
        "el-icon-news",
        "el-icon-menu",
        "el-icon-tickets",
        "el-icon-document",
        "el-icon-star-on",
        "el-icon-money",
        "el-icon-date",
        "el-icon-setting"
      ],
      dpath: "/plist",

      updatePwd: false,
      form: { old_password: "", new_password: "" }
    };
  },
  created() {
    let that = this;
    document.onkeydown = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.updatePwd) {
        that.changePwd();
        return false;
      }
    };
  },
  methods: {
  	goHome(){
  		window.location.href='https://home.yxcg.net/'
  	},
    cpwd() {
      this.form = { old_password: "", new_password: "" };
      this.updatePwd = true;
    },
    changePwd() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          scpwd(this.form, this.$cookie.getCookie("login")).then(res => {
            if (res.code == 200) {
              this.updatePwd = false;
              this.$router.push({ path: "/login" });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },


    handleselect: function(a, b) {},
    //退出登录
    logout: function() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          // sessionStorage.removeItem("user");
          _this.$router.push("/login");
        })
        .catch(() => {});
    },
    //折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    }
  },
  mounted() {
    var that = this;
    this.dpath = this.$route.path;
    if (this.$cookie.getCookie("user")) {
      this.uName = decodeURIComponent(this.$cookie.getCookie("user"));
    }
    if (window.screen.width < 500) {
      this.collapsed = true;
      this.$store.isPhone = true;
    }
    //获取配置文件
    sconfig(this.$cookie.getCookie("login")).then(res => {
      if (res.code == 200) {
        this.$store.config = res.data;
      }
    });
    smenu(this.$cookie.getCookie("login")).then(res => {
      if (res.code == 200) {
        this.menu = res.data;
      }
    });

    swxapp("kw=", this.$cookie.getCookie("login")).then(res => {
      if (res.code == 200) {
        this.$store.applist = res.data;
      }
    });
    slist("page=1&perpage=100", this.$cookie.getCookie("login")).then(res => {
      if (res.code == 200) {
        var arr = [];
        res.data.list.forEach(v => {
          arr.push({ id: v.id, name: v.version });
        });
        this.$store.vlist = arr;
      }
    });
//  splist("page=1&perpage=1000", this.$cookie.getCookie("login")).then(res => {
//    if (res.code == 200) {
//      // var arr=[];
//      // res.data.list.forEach(v=>{
//      //   arr.push({id:v.id,name:v.name})
//      // })
//      this.$store.plist = res.data.list;
//    }
//  });
    var _this=this;
    window.onresize = () => {
      return (() => {
        if (_this.$route.path == "/creativeData/index"||_this.$route.path == "/spaceData/index"||_this.$route.path == "/income/index") {
          if (_this.$refs.myMain.timer) {
            clearTimeout(_this.$refs.myMain.timer);
          }
          _this.$refs.myMain.timer = setTimeout(() => {
            _this.$refs.myMain.chartColumn.resize();
          }, 200);
        }
      })();
    };
  }
};
</script>

<style scoped lang="scss">
@import "~scss_vars";

.container {
  // background: #F2F6FC;
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;
    border-bottom:1px solid #e6e6e6;
    /*background: $color-primary;*/
   
    color: #333333;
    .userinfo {
      // background: $color-primary;
      // line-height: 0;
      height: 60px;
      text-align: right;
      padding-right: 35px;
      box-sizing: border-box;
      float: right;
      .userinfo-inner {
        cursor: pointer;
        color: #333333;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 10px 0px 10px;
          float: left;
        }
      }
    }
    .logo {
      /*//width:230px;*/
      /*background: $linear;*/
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      box-sizing: border-box;
      border-color: rgba(238, 241, 146, 0.3);
      border-right-width: 1px;
      border-right-style: solid;
      transition: all 0.3s;
      color:#333333;
      img {
      	 width: 40px;
		    height: 40px;
		    display: inline-block;
		    vertical-align: middle;
		    margin: 0 5px;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      /*width: 230px;*/
      max-width: 50%;
    }
    .logo-collapse-width {
      padding: 0;
      width: 0px;
    }
    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;
    aside {
      flex: 0 0 170px;
      width: 170px;

      .el-menu {
        height: 100%;
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
      .expanded {
        width: 170px !important;
      }
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
      transition: all 0.5s;
    }
    .menu-expanded {
      flex: 0 0 170px;
      width: 170px;
    }
    .content-container {
      flex: 1;
      overflow: scroll;
      padding: 20px;
      background: #f2f6fc;
      .breadcrumb-container {
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }
      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
	.container .main .menu-collapsed{
		flex: 0 0 0px;
    width: 0px;
    transition: all 0.1s;
    display: none;
	}
  .container {
    font-size: 12px;
    .main {
      aside {
       /* display: none;*/
      }
      .content-container {
        padding: 5px;
      }
    }
  }
}
</style>

<style type="text/css">
	.el-table th>.cell{
		white-space: nowrap !important;
	}
	.el-table .cell{
		white-space: nowrap !important;
		text-overflow: initial !important;
	}
</style>


// WEBPACK FOOTER //
// Home.vue?d851a354